import React, { useState } from 'react';
import './FAQ.scss';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "How long does the battery last?",
      answer: "Shadow Tracker has an industry-leading 24-month battery life on a single charge. The device uses advanced power management to maximize longevity while maintaining real-time tracking capabilities."
    },
    {
      question: "Do I need a monthly subscription?",
      answer: "Yes, Shadow Tracker requires a monthly subscription ($15.95/month) for cellular connectivity and app access. This includes unlimited tracking, real-time alerts, and location history with no contracts - cancel anytime."
    },
    {
      question: "How accurate is the GPS tracking?",
      answer: "Shadow Tracker uses multi-constellation GPS (GPS, GLONASS, Galileo) for pinpoint accuracy within 5-10 meters. In urban areas with good cellular coverage, accuracy can be even better."
    },
    {
      question: "Is it weatherproof?",
      answer: "Yes! Shadow Tracker is IP67 rated, meaning it's fully dust-proof and can withstand immersion in water up to 1 meter for 30 minutes. Perfect for outdoor equipment, vehicles, and marine applications."
    },
    {
      question: "How do I install it?",
      answer: "Installation is simple - just place the device in a hidden location on your asset. The magnetic mount makes it easy to attach to metal surfaces. No wiring required. Full installation guide included."
    },
    {
      question: "What's your return policy?",
      answer: "We offer a 30-day money-back guarantee. If you're not completely satisfied with Shadow Tracker, return it for a full refund - no questions asked. We also provide a 1-year manufacturer warranty."
    },
    {
      question: "Can thieves detect it?",
      answer: "Shadow Tracker is designed to be completely stealth. It has no lights, sounds, or external indicators. The compact size and weatherproof design allow it to be hidden in countless locations."
    },
    {
      question: "Does it work internationally?",
      answer: "Yes! Shadow Tracker works in over 150 countries with global cellular coverage. Perfect for tracking assets that cross borders or for international travel."
    }
  ];

  return (
    <section className="faq">
      <div className="container">
        <h2>Frequently Asked Questions</h2>
        <p className="subtitle">Everything you need to know about Shadow Tracker</p>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <div className="faq-question">
                <span>{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
